import { Badge, Box, Card, CardBody, Flex, Icon, Skeleton, Text } from "@chakra-ui/react";
import { useContext } from "react";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";

function DeltaBadge({ delta_pct }) {
  if (delta_pct === null || delta_pct === undefined) {
    return <Badge colorScheme="gray" fontSize="xs">—</Badge>;
  }
  const positive = delta_pct >= 0;
  return (
    <Badge colorScheme={positive ? "green" : "red"} fontSize="xs">
      {positive ? "↑" : "↓"} {Math.abs(delta_pct)}%
    </Badge>
  );
}

export default function StatCard({ title, value, subvalue, delta_pct, icon, isLoading }) {
  const { textColor, cardBg } = useContext(AgencyContext);
  return (
    <Card variant="elevated" bg={cardBg} h="100%">
      <CardBody p={4}>
        <Flex direction="column" gap={2} h="100%">
          <Flex align="center" gap={2}>
            {icon && <Icon as={icon} boxSize={4} color="gray.400" />}
            <Text fontSize="xs" color="gray.500" fontWeight="medium" textTransform="uppercase" letterSpacing="wide">
              {title}
            </Text>
          </Flex>
          <Skeleton isLoaded={!isLoading} fitContent>
            <Text fontSize="2xl" fontWeight="bold" color={textColor} lineHeight="1">
              {value ?? "—"}
            </Text>
          </Skeleton>
          <Flex align="center" gap={2} mt="auto">
            {isLoading ? <Skeleton h="18px" w="48px" borderRadius="full" /> : <DeltaBadge delta_pct={delta_pct} />}
            <Text fontSize="xs" color="gray.400">vs prev period</Text>
          </Flex>
          {subvalue && (
            <Text fontSize="xs" color="gray.400">{subvalue}</Text>
          )}
        </Flex>
      </CardBody>
    </Card>
  );
}
